import GatewayForm from '../screens/GatewayForm'
import GatewayFormEdit from '../screens/GatewayFormEdit'
import GatewayList from '../screens/GatewayList'
import { ROLE, RouteWithAccessType } from './types'

const gatewayPagesRoleManagement: RouteWithAccessType[] = [
  {
    route: '/gateway',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['gateway.list.view'],
    component: <GatewayList />
  },
  {
    route: '/gateway/:id/details',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['gateway.details.view'],
    component: <GatewayFormEdit />
  },
  {
    route: '/gateway/create',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['gateway.create'],
    component: <GatewayForm />
  }
]

export default gatewayPagesRoleManagement
